import { render } from "./CollectionView.vue?vue&type=template&id=c2ede49a"
import script from "./CollectionView.vue?vue&type=script&lang=js"
export * from "./CollectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__